import { render } from "./editorRelatorio.vue?vue&type=template&id=8bb48cf6&scoped=true"
import script from "./editorRelatorio.vue?vue&type=script&lang=js"
export * from "./editorRelatorio.vue?vue&type=script&lang=js"

import "./editorRelatorio.vue?vue&type=style&index=0&id=8bb48cf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb48cf6"]])

export default __exports__